import { Button } from '@commenda/kakashi';
import { cn } from '@commenda/utils';

interface EmptyStateV2Props {
  title: string;
  description: React.ReactNode;
  icon?: React.ReactNode;
  action?: {
    label: string;
    icon?: React.ReactNode;
    onClick: () => void;
  };
  className?: string;
}

function EmptyStateV2({
  title,
  description,
  action,
  icon,
  className,
}: EmptyStateV2Props) {
  return (
    <div
      className={cn(
        'flex items-center justify-center w-full bg-bg-secondary rounded-2xl p-3xl border border-border-primary h-full min-h-[248px]',
        className
      )}
    >
      <div className="flex flex-col gap-4 items-center">
        {icon}
        <div className="flex flex-col items-center gap-1">
          <h3 className="txt-medium-bold text-text-primary py-1">{title}</h3>
          <p className="txt-small-regular text-text-tertiary text-center px-2 text-balance">
            {description}
          </p>
        </div>
        {action ? (
          <Button variant="primary" className="mt-2" onClick={action.onClick}>
            {action.icon ?? null}
            <span className="txt-small-bold">{action.label}</span>
          </Button>
        ) : null}
      </div>
    </div>
  );
}

export { EmptyStateV2 };
